import { useCallback } from 'react';
import { SweepCanvasRfNode } from '../canvas-types/nodeTypesData';
import { useSweepCanvasState } from '../internal-context/CanvasStateContext';

export const useMultipleSelection = () => {
  const { setCanvasNodes } = useSweepCanvasState();

  const onSelectionChange = useCallback(
    ({ nodes: selectedNodes }: { nodes: SweepCanvasRfNode[] }) => {
      const selectedNodeIds = selectedNodes.map((node) => node.id);

      setCanvasNodes((prev) => {
        return prev.map((node) => {
          if (selectedNodeIds.includes(node.id)) {
            if (!node.selected) {
              return { ...node, selected: true };
            }
          }
          return node;
        });
      });
    },
    [setCanvasNodes],
  );

  return { onSelectionChange };
};
